import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'agr-loading-dots',
  templateUrl: './loading-dots.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LoadingDotsComponent {
  @Input() color: '' | 'colors' | 'yellow' | 'gray' = 'gray';
  @Input() size: '' | 'big' | 'small' = '';
}
